import { StaticQuery, graphql } from "gatsby";
import React from "react";

import {
  Section,
  Image,
  Card,
  Header2,
  Underlined,
  Paragraph,
} from "@racepointenergy/gatsby-theme-sitespark/src/components/Hero";
import { getSize } from "@racepointenergy/gatsby-theme-sitespark/src/components/Theme/utils";

import { Link } from "components/CallToAction";

export const LetsBuildABetterGrid = () => (
  <Section
    css={`
      @media screen and (min-width: ${getSize("tablet720")}) {
        justify-content: flex-end;
      }
    `}
  >
    <StaticQuery
      query={graphql`
        query LetsBuildABetterGridImageQuery {
          file(relativePath: { eq: "Grid.png" }) {
            ...HeroImage
          }
        }
      `}
      render={({ file }) => (
        <Image
          alt=""
          css={`
            + picture > img,
            img {
              object-position: 70% 50%;
              @media screen and (min-width: ${getSize("tablet720")}) {
                object-position: 50% 50%;
              }
            }
          `}
          file={file}
        />
      )}
    />
    <Card
      css={`
        @media screen and (min-width: ${getSize(
            "tablet720"
          )}) and (max-width: 959px) {
          width: 410px;
        }
        @media screen and (min-width: ${getSize(
            "desktop1200"
          )}) and (max-width: 1919px) {
          width: 450px;
        }
        @media screen and (min-width: ${getSize("desktop1920")}) {
          width: 536px;
        }
      `}
    >
      <Header2>
        {"Let’s Build a Better Grid"}
        <Underlined />
      </Header2>
      <Paragraph>
        {
          "Reliable geographically based load data allows utilities to make deliberate and targeted load manipulation avoiding more dramatic curtailments, including brownouts or blackouts."
        }
      </Paragraph>
      <div
        css={`
          margin-top: 22px;
          @media screen and (min-width: ${getSize(
              "mobile480"
            )}) and (max-width: 719px) {
            margin-top: 27px;
          }
          @media screen and (min-width: ${getSize("tablet720")}) {
            margin-top: 23px;
          }
          @media screen and (min-width: ${getSize("tablet768")}) {
            margin-top: 24px;
          }
          @media screen and (min-width: ${getSize("desktop1920")}) {
            margin-top: 35px;
          }
        `}
      >
        <Link to="/get-a-preliminary-proposal">{"Contact Us"}</Link>
      </div>{" "}
    </Card>
  </Section>
);
